import { createZustandStore } from '../../../zustand';

import {
  IEvaluationStore,
  IPendingFileUploadFormat,
  TSetIEvaluationStoreState,
} from './types';

export function onSetPendingUploads(set: TSetIEvaluationStoreState) {
  return function setPendingUploads(
    imageIdentifier: string,
    uploads: IPendingFileUploadFormat[]
  ) {
    set((state) => ({
      pendingUploads: {
        ...state.pendingUploads,
        [imageIdentifier]: uploads,
      },
    }));
  };
}

/**
 * This creates a local global state for managing the evaluation image store.
 */
export const useEvaluationImageStore = createZustandStore<IEvaluationStore>()(
  (set) => ({
    sessionId: null,
    setSessionId: (id) => set(() => ({ sessionId: id })),
    port: null,
    setPort: (port) => set(() => ({ port })),
    imagesConfiguration: [],
    selectedEvaluationAsset: null,
    updateSelectedEvaluationAsset: (asset) =>
      set(() => ({ selectedEvaluationAsset: asset })),
    updateImagesConfiguration: (imagesConfiguration) =>
      set(() => ({ imagesConfiguration })),
    pendingUploads: {},
    doneUploads: {},
    resetDoneUploads: () => set(() => ({ doneUploads: {} })),
    setPendingUploads: onSetPendingUploads(set),
    setDoneUploads: (key, uploads) => {
      set((state) => ({
        doneUploads: {
          ...state.doneUploads,
          [key]: uploads,
        },
      }));
    },
  })
);
